var _path, _g, _path2, _g2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_3330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 7,
    width: 18,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 7.32837H18.3333V18.7817H1.66699V7.32837Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_3330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6378 18.7817H5.36283C3.32533 18.7817 1.66699 17.1242 1.66699 15.0859V11.0234C1.66699 8.98587 3.32533 7.32837 5.36283 7.32837H6.14033C6.48533 7.32837 6.76533 7.60837 6.76533 7.95337C6.76533 8.29837 6.48533 8.57837 6.14033 8.57837H5.36283C4.01366 8.57837 2.91699 9.67504 2.91699 11.0234V15.0859C2.91699 16.435 4.01366 17.5317 5.36283 17.5317H14.6378C15.9862 17.5317 17.0837 16.435 17.0837 15.0859V11.0159C17.0837 9.6717 15.9903 8.57837 14.647 8.57837H13.8612C13.5162 8.57837 13.2362 8.29837 13.2362 7.95337C13.2362 7.60837 13.5162 7.32837 13.8612 7.32837H14.647C16.6795 7.32837 18.3337 8.98254 18.3337 11.0159V15.0859C18.3337 17.1242 16.6753 18.7817 14.6378 18.7817Z",
    fill: "#2E90FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_443_3330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 1,
    width: 2,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 1.66675H10.625V12.9508H9.375V1.66675Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_443_3330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.9508C9.655 12.9508 9.375 12.6708 9.375 12.3258V2.29163C9.375 1.94663 9.655 1.66663 10 1.66663C10.345 1.66663 10.625 1.94663 10.625 2.29163V12.3258C10.625 12.6708 10.345 12.9508 10 12.9508Z",
    fill: "#2E90FA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57084 5.35727C7.41167 5.35727 7.25167 5.29644 7.13001 5.17477C6.88584 4.93144 6.88417 4.53644 7.12834 4.29144L9.55751 1.85144C9.79167 1.6156 10.2083 1.6156 10.4425 1.85144L12.8725 4.29144C13.1158 4.53644 13.115 4.93144 12.8708 5.17477C12.6258 5.4181 12.2308 5.4181 11.9875 5.1731L10 3.1781L8.01334 5.1731C7.89167 5.29644 7.73084 5.35727 7.57084 5.35727Z",
    fill: "#2E90FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.21549632.svg";
export { ForwardRef as ReactComponent };